import React, { Suspense, lazy, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import InitialLoader from './components/InitialLoader';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

// Lazy load below-the-fold components
const FeaturesSection = lazy(() => import('./components/FeaturesSection'));
const BenefitsSection = lazy(() => import('./components/BenefitsSection'));
const AdvantagesSection = lazy(() => import('./components/AdvantagesSection'));
const HowItWorks = lazy(() => import('./components/HowItWorks'));
const NextGenSection = lazy(() => import('./components/NextGenSection'));
const FAQSection = lazy(() => import('./components/FAQSection'));
const ComingSoon = lazy(() => import('./pages/ComingSoon'));
const CTASection = lazy(() => import('./components/CTASection'));
const Footer = lazy(() => import('./components/Footer'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsOfService = lazy(() => import('./pages/TermsOfService'));

// Simple loading fallback
const SectionLoader = () => (
  <div className="py-20 flex items-center justify-center bg-[#0d0d10]">
    <div className="w-8 h-8 border-4 border-[#3bd07a]/20 border-t-[#3bd07a] rounded-full animate-spin" />
  </div>
);

function App() {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <Router>
      <ScrollToTop />
      <div className="App font-inter antialiased bg-[#0d0d10]">
        <AnimatePresence mode="wait">
          {isLoading && <InitialLoader onComplete={() => setIsLoading(false)} />}
        </AnimatePresence>

        <Suspense fallback={<SectionLoader />}>
          <Routes>
            {/* Redirect root to coming-soon if you want it to be the main landing for now */}
            <Route path="/coming-soon" element={<ComingSoon />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/" element={
              <>
                <Header />
                <HeroSection />
                <FeaturesSection />
                <BenefitsSection />
                <AdvantagesSection />
                <HowItWorks />
                <NextGenSection />
                <FAQSection />
                <CTASection />
                <Footer />
              </>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;